const roundRawUSD = (number: any) => {
  if (number === undefined) {
    return 0;
  }

  return Math.round(number / 10) * 10;
};

export default roundRawUSD;
